import React from 'react';

import { TeamKpiSettingsProps } from '../../types';

export const TeamKpiSettings: React.FC<TeamKpiSettingsProps> = () => {
    return <div />;
};
